if (!customElements.get('wepack-sticky-usps')) {
  customElements.define('wepack-sticky-usps', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-usp]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.timer = setInterval(() => {
        if (this.motion.matches || document.hidden ||
          !this.closest('.sticky-cta')?.hasAttribute('data-past-inline') || this.items.length < 2) return;
        this.items[this.index].classList.remove('is-active');
        this.fadeTimer = setTimeout(() => {
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
        }, 320);
      }, 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.fadeTimer);
    }
  });
}
